export interface KrampShippingAddress {
  id: number;
  customerId: string;
  name: string;
  comment: string | null;
  address: string;
  zipCode: string;
  city: string;
  shipToNo: string;
  hasNightShipping: boolean;
  active: boolean;
  inTransit: boolean;
  modifiedBy: string;
  lastModified: string;
}

export const EmptyKrampShippingAddress = (): KrampShippingAddress => ({
  id: -1,
  customerId: '',
  name: '',
  comment: '',
  address: '',
  zipCode: '',
  city: '',
  shipToNo: '',
  hasNightShipping: false,
  active: true,
  inTransit: false,
  modifiedBy: '',
  lastModified: '',
});
